import get from 'lodash/get'
import * as Sentry from '@sentry/browser'

import {
  newSavedSearch,
  removeSavedSearch,
  getSavedSearches,
} from 'src/api/nestready/requests'

import {
  CREATE_SAVED_SEARCH_REQUEST,
  CREATE_SAVED_SEARCH_SUCCESS,
  CREATE_SAVED_SEARCH_FAILURE,
  DELETE_SAVED_SEARCH_REQUEST,
  DELETE_SAVED_SEARCH_SUCCESS,
  DELETE_SAVED_SEARCH_FAILURE,
  FETCH_SAVED_SEARCHES_REQUEST,
  FETCH_SAVED_SEARCHES_SUCCESS,
  FETCH_SAVED_SEARCHES_FAILURE,
} from './actionTypes'

export const createSavedSearch = (customerId, filters) => async (dispatch) => {
  dispatch({
    type: CREATE_SAVED_SEARCH_REQUEST,
  })

  try {
    const response = await newSavedSearch(customerId, filters)
    const savedSearch = get(response, 'data.data')

    dispatch({
      type: CREATE_SAVED_SEARCH_SUCCESS,
      savedSearch,
    })
  } catch (error) {
    Sentry.captureException(error)
    dispatch({
      type: CREATE_SAVED_SEARCH_FAILURE,
      error,
    })
  }
}

export const fetchSavedSearches = (customerId) => async (dispatch) => {
  dispatch({
    type: FETCH_SAVED_SEARCHES_REQUEST,
  })

  try {
    const response = await getSavedSearches(customerId)
    const savedSearches = get(response, 'data.data')

    dispatch({
      type: FETCH_SAVED_SEARCHES_SUCCESS,
      savedSearches,
    })
  } catch (error) {
    Sentry.captureException(error)
    dispatch({
      type: FETCH_SAVED_SEARCHES_FAILURE,
      error,
    })
  }
}

export const deleteSavedSearch =
  (customerId, locationId) => async (dispatch) => {
    dispatch({
      type: DELETE_SAVED_SEARCH_REQUEST,
    })

    try {
      const response = await removeSavedSearch(customerId, locationId)
      const savedSearch = get(response, 'data.data')

      dispatch({
        type: DELETE_SAVED_SEARCH_SUCCESS,
        savedSearch,
      })
    } catch (error) {
      Sentry.captureException(error)
      dispatch({
        type: DELETE_SAVED_SEARCH_FAILURE,
        error,
      })
    }
  }
